import { render, staticRenderFns } from "./ProspectsList.vue?vue&type=template&id=ae7388dc&"
import script from "./ProspectsList.vue?vue&type=script&lang=js&"
export * from "./ProspectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports